angular.module('ics')
    .controller('ReportEmailTemplatesAdminController', function ($scope, $state, $controller, $timeout,
                                                              ReportEmailTemplatesService,
                                                              FirebaseAuthService) {
        $scope.item = {

            emailTemplateId: '',
            templateName: '',
            emailSubject: '',
            emailBody: ''

        };

        $scope.editing = false;
        $scope.errorMessage = '';
        $scope.tokenId = '';
        $scope.processing = true;

        angular.extend(this, $controller('BaseAdminController', {$scope: $scope}));

        FirebaseAuthService.getUserToken()
            .then(tokenId => {
                $scope.tokenId = tokenId;
                $scope.init();
            })
            .catch(err => $scope.checkErrStatus(err));

        $scope.init = function () {
            $scope.processing = true;

            ReportEmailTemplatesService
                .getReportEmailTemplatesList($scope.tokenId, $scope.visitorId)
                .then((response) => {
                    $scope.emailTemplatesList = response.data.report_email_templates;
                    reset();
                })
                .catch(err => $scope.checkErrStatus(err));
        };

        $scope.submitForm = function ($form) {
            if ($form.$valid) {
                $scope.saveEmailTemplate(
                    $scope.item.templateName,
                    $scope.item.emailSubject,
                    $scope.item.emailBody);
            }
        };

        $scope.saveEmailTemplate = function (templateName, emailSubject,
                                             emailBody) {
            $scope.errorMessage = '';
            $scope.processing = true;
            if ($scope.item.emailTemplateId === '') {
                ReportEmailTemplatesService
                    .createReportEmailTemplate(
                        templateName,
                        emailSubject,
                        emailBody,
                        $scope.tokenId, $scope.visitorId)
                    .then(() => location.reload())
                    .catch(err => $scope.checkErrStatus(err));
            } else {
                ReportEmailTemplatesService
                    .editReportEmailTemplate(
                        $scope.item.emailTemplateId,
                        templateName,
                        emailSubject,
                        emailBody,
                        $scope.tokenId, $scope.visitorId)
                    .then(() => location.reload())
                    .catch(err => $scope.checkErrStatus(err));
            }
        };

        $scope.deleteEmailTemplate = function (emailTemplateId, index) {
            $('#modalConfirmHeader').html('Deleting Email Template');
            $('#modalConfirmText').html('Are you sure you want to delete this item?');

            const deleteType = function () {

                ReportEmailTemplatesService
                    .deleteReportEmailTemplate(this.emailTemplateId, $scope.tokenId, $scope.visitorId)
                    .then(() => location.reload())
                    .catch(err => $scope.checkErrStatus(err));

            };

            const deletionEvent = deleteType.bind({emailTemplateId: emailTemplateId});

            $(document).ready(function () {

                $('#modalAgreeLink').click(function () {
                    deletionEvent();
                    $('#are_you_sure_modal').modal('close');
                });

                $('#are_you_sure_modal').modal('open');

            });
        };

        $scope.editEmailTemplate = function (emailTemplateId, index) {
            $('body').removeClass('bg-grey-1');
            $scope.item.emailTemplateId = emailTemplateId;
            $scope.item.templateName = $scope.emailTemplatesList[index].template_name;
            $scope.item.emailSubject = $scope.emailTemplatesList[index].email_subject;
            $scope.item.emailBody = $scope.emailTemplatesList[index].email_body;

            $timeout(function () {
                $('select').material_select();
                $('textarea').trigger('autoresize');
            });

            $scope.editing = true;
        };

        $scope.addEmailTemplate = function () {
            $('body').removeClass('bg-grey-1');
            $scope.item.emailTemplateId = '';
            $scope.item.templateName = '';
            $scope.item.emailSubject = '';
            $scope.item.emailBody = '';

            $scope.editing = true;
            $scope.errorMessage = '';

            $timeout(function () {
                $('select').material_select();
                $('textarea').trigger('autoresize');
            });
        };

        $scope.cancelSaveEmailTemplate = function () {
            $('body').addClass('bg-grey-1');
            reset();
        };

        function reset () {
            $scope.processing = false;
            $scope.editing = false;
            $scope.errorMessage = '';

            $scope.item.templateName = '';
            $scope.item.emailSubject = '';
            $scope.item.emailBody = '';
        }

    });